export enum ShovelFloorControlStatusEnum {
    Unknown = 0,
    Active = 1,
    Maintenance = 2,
}